/// \file updateCookie.ts
///
/// \par Copyright Notice:
/// Copyright (c) 2024 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import LocalDBCalls from "./localDBCalls";

const updateCookie = {
    updateTokenTime: function(){
        const headerCookies = document.cookie;
        const cookies = headerCookies.split(";");
        let foundToken = false;
        for(let i=0;i<cookies.length;i++){
            const cookieString = cookies[i].replaceAll(" ","").split("=");
            const cookieName = cookieString[0];
            if(cookieName=="token"){
                const now = new Date();
                const time = now.getTime();
                var expireTime = time + 1000*60*45;
                now.setTime(expireTime)
                document.cookie = "token="+cookieString[1]+"; Path=/;Expires="+now.toUTCString();
                foundToken = true;
                console.log("updateTokenTime: updated token")
                this.checkTokenValid()
            }
        }
        if(!foundToken){
            //reload page
            const pathname = window.location.pathname
            console.log("pathname: ", pathname);
            if(!pathname.includes("/auth/")){
                window.location.reload()
            }

        }
    },
    checkTokenValid: async function(){ //checks the token to see if it good.  if not, removes and send to signin
        const testToken = await LocalDBCalls.checkUserIsValid()
        if(testToken!=1){
            document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            const pathname = window.location.pathname
            console.log("bad token:\npathname: ", pathname);
            if(!pathname.includes("/auth/")){
                window.location.reload()
            }
        }
        return("");
    },
}
export default updateCookie;